export default "__VITE_PUBLIC_ASSET__12e06088__"